import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=f65c9140"
import script from "./tixian.vue?vue&type=script&lang=js"
export * from "./tixian.vue?vue&type=script&lang=js"
import style0 from "./tixian.vue?vue&type=style&index=0&id=f65c9140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports